import useScript from './useScript'
import { commonPub } from '../config/dataConf'

const usePub = (divRef, coreScript) => {
  useScript(commonPub, divRef, true)
  useScript(null, divRef, true, coreScript, '__lxGc__')
}

export default usePub
